import DocumentationForm from "./DocumentationForm";
import DocumentationFormSummary from "./DocumentationFormSummary";
import React from "react";
import {STATUS_MODEL} from "../../../../../../enums/statusEnum";
import DocumentationFormRequestForm from "./DocumentationFormRequestForm";
import {TAB_INDEX} from "../../Model/Model";
/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const Steps = ({activeStep, t,getInvitationById,data,handleChange,emptyFields,StepLoading, photoPickerList, setPhotoPickerList,
                   handleDeletePhotoPicker, isValidData }) => {

    const renderCompleteSteps = () => {
        switch (activeStep) {
            case TAB_INDEX.ONE:
                return (
                    <>
                        {
                            getInvitationById?.invitation?.statusId === STATUS_MODEL.CHANGES_REQUESTED ?
                                <DocumentationFormRequestForm
                                    data={data}
                                    t={t}
                                    emptyFields={emptyFields}
                                    handleChange={handleChange}
                                    getInvitationById={getInvitationById}
                                    photoPickerList={photoPickerList}
                                    setPhotoPickerList={setPhotoPickerList}
                                    handleDeletePhotoPicker={handleDeletePhotoPicker}
                                    isValidData={isValidData}
                                />
                                :
                                <DocumentationForm
                                    data={data}
                                    t={t}
                                    emptyFields={emptyFields}
                                    handleChange={handleChange}
                                    getInvitationById={getInvitationById}
                                    photoPickerList={photoPickerList}
                                    setPhotoPickerList={setPhotoPickerList}
                                    isValidData={isValidData}
                                />
                        }
                    </>
                );
            case TAB_INDEX.TWO:
                return (
                       <DocumentationFormSummary
                           data={data}
                           t={t}
                           emptyFields={emptyFields}
                           handleChange={handleChange}
                           getInvitationById={getInvitationById}
                           photoPickerList={photoPickerList}
                       />
                );
            case TAB_INDEX.THREE:
                return (
                    <>
                        <StepLoading />
                    </>
                );
            default:
                return null;
        }
    };

    return {renderCompleteSteps}

}

export default Steps
